/* eslint-disable */
import envIsProduction from '../../Support/Env/IsProduction/EnvIsProduction.support';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the _value_ of an environment value is `undefined`
 * @export
 * @class EnvUndefinedValueError
 * @extends {Error}
 */
export class EnvUndefinedValueError extends Error {
  /**
   * Creates an instance of EnvUndefinedValueError
   * @param {string} message The Error `message`
   * @memberof EnvUndefinedValueError
   */
  constructor(message) {
    super(message);
    this.name = `EnvUndefinedValueError`;
  }
}

/**
 * Called when the _value_ of an environment value is `undefined`
 * @param {string} key The `key` pointing to the invalid value
 * @returns {never} never
 */
const throwEnvUndefinedValueError = (key) => {
  const filename = envIsProduction() ? `.env` : `.env.${process.env.NODE_ENV}`;
  throw new EnvUndefinedValueError(
    stripIndent(`
    Could not find environment variable "${key}".
    Has it been set in an "${filename}" file?
    See https://medium.com/@tacomanator/environments-with-create-react-app-7b645312c09d for an overview.
    `),
  );
};

export default throwEnvUndefinedValueError;
